import React from "react";
import PropTypes from 'prop-types';
import { TextField } from "../../index";

export const PhoneNumber = ({
    label="Phone number",
    maxLength = 12,
    onChange = () => { },
    onKeyUp = () => { },
    onKeyDown = () => { },
    ...props
}) => {

    const isNumericInput = (event) => {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    };

    const isModifierKey = (event) => {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    };

    const handleOnChange = (event) => {
        onChange(event);
    }

    const handleOnKeyUp = (e) => {
        if (isModifierKey(e)) { return; }
        e.persist();
        var formatTarget = e.target;
        const input = e.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
        const first = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);
        if (input.length > 5) {
            formatTarget.value = `${first}.${middle}.${last}`;
        } else if (input.length > 2) {
            formatTarget.value = `${first}.${middle}`;
        } else if (input.length > 0) {
            formatTarget.value = `${first}`
        }
        e.target = formatTarget;
        handleOnChange(e);
        onKeyUp(e);
    }

    const handleOnKeyDown = (event) => {
        if (!isNumericInput(event) && !isModifierKey(event)) {
            event.preventDefault();
        }

        onKeyDown(event);
    };

    return (
        <TextField
            {...props}
            label={label}
            maxLength={maxLength}
            onChange={handleOnChange}
            onKeyUp={handleOnKeyUp}
            onKeyDown={handleOnKeyDown}
        />
    )
}

PhoneNumber.propTypes = {
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onKeyUp: PropTypes.func,
    onKeyDown: PropTypes.func,
}